import { render, staticRenderFns } from "./OrderModifiers.vue?vue&type=template&id=36b88c78"
import script from "./OrderModifiers.vue?vue&type=script&lang=ts"
export * from "./OrderModifiers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports